import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { PageContentWrapper, PageHeader, PageDescription } from '../main/LayoutStyles';
import { Card, AlertBox } from '../main/CommonStyles';
import { useTheme } from 'styled-components'; // <-- NOWY IMPORT

const HelpPage = () => {
    const theme = useTheme(); // <-- POPRAWKA: Użycie hooka useTheme
    return (
        <PageContentWrapper className="custom-scrollbar">
            <PageHeader>Pomoc i Wsparcie</PageHeader>
            <PageDescription>
                Jeśli potrzebujesz natychmiastowej pomocy lub znajdujesz się w kryzysie, skontaktuj się z odpowiednimi służbami.
                Ta aplikacja nie zastępuje profesjonalnej pomocy psychologicznej.
            </PageDescription>
            <AlertBox>
                <ShieldCheck size={24}/>
                <div>
                    <p><strong>Ważne!</strong></p>
                    <p>Jeśli doświadczasz myśli samobójczych lub jesteś w sytuacji zagrożenia życia, natychmiast skontaktuj się z numerem alarmowym <strong>112</strong> lub specjalistyczną linią wsparcia.</p>
                </div>
            </AlertBox>
            <Card>
                <h3 style={{fontSize: '1.25rem', fontWeight: 600, color: theme.colors.primaryDark, marginBottom: theme.spacing.sm}}>Telefony Zaufania:</h3>
                <ul style={{listStyle: 'disc', paddingLeft: theme.spacing.lg, color: theme.colors.textMedium, fontSize: '0.875rem', display: 'flex', flexDirection: 'column', gap: theme.spacing.xs}}>
                    <li>Telefon Zaufania dla Dorosłych: <a href="tel:116123" onClick={() => console.log("HelpPage: Tel Zaufania Dorosli clicked")}>116 123</a></li>
                    <li>Telefon Zaufania dla Dzieci i Młodzieży: <a href="tel:116111" onClick={() => console.log("HelpPage: Tel Zaufania Dzieci clicked")}>116 111</a></li>
                </ul>
                <hr style={{margin: `${theme.spacing.md} 0`, borderColor: theme.colors.borderColor}}/>
                <h3 style={{fontSize: '1.25rem', fontWeight: 600, color: theme.colors.primaryDark, marginBottom: theme.spacing.sm}}>FAQ - Najczęściej Zadawane Pytania:</h3>
                <p style={{color: theme.colors.textMedium, fontSize: '0.875rem'}}>Tutaj znajdziesz odpowiedzi na popularne pytania dotyczące aplikacji.</p>
                <hr style={{margin: `${theme.spacing.md} 0`, borderColor: theme.colors.borderColor}}/>
                <h3 style={{fontSize: '1.25rem', fontWeight: 600, color: theme.colors.primaryDark, marginBottom: theme.spacing.sm}}>Kontakt z Nami:</h3>
                <p style={{color: theme.colors.textMedium, fontSize: '0.875rem'}}>Jeśli masz pytania techniczne lub uwagi dotyczące aplikacji, napisz do nas: <a href="mailto:pomoc@epsycholog.pl" onClick={() => console.log("HelpPage: Kontakt email clicked")}>pomoc@epsycholog.pl</a></p>
            </Card>
        </PageContentWrapper>
    );
}

export default HelpPage;